import { dom, library, config } from '@fortawesome/fontawesome-svg-core'
import {
  faLongArrowLeft,
  faLongArrowRight,
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faPlus,
  faTimes
} from '@fortawesome/pro-regular-svg-icons'
import {
  faPlay,
  faSearch
} from '@fortawesome/pro-solid-svg-icons'
import {
  faTwitter,
  faFacebook,
  faFacebookF,
  faYoutube,
  faLinkedin,
  faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons'

config.searchPseudoElements = true

// Add fontawesome icons
library.add(
  faLongArrowLeft,
  faLongArrowRight,
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faPlay,
  faPlus,
  faTimes,
  faTwitter,
  faFacebook,
  faFacebookF,
  faYoutube,
  faLinkedin,
  faLinkedinIn,
  faSearch
)

document.addEventListener('turbolinks:load', () => dom.i2svg())
